module.exports = __webpack_public_path__ + "img/Ei5n6vBWoAEy5gp-min.c7ad3d2c.png";